<template>
  <div
    ref="kt_modal_variacao_padrao"
    data-bs-backdrop="static"
    data-bs-focus="false"
    class="modal fade modal-overlay"
    tabindex="-1"
    id="kt_modal_variacao_padrao"
  >
    <div
      class="modal-dialog modal-md modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-body p-0">
          <div class="card">
            <div class="card-header">
              <div class="card-title d-flex align-items-center">
                <span class="svg-icon svg-icon-1 svg-icon me-3 lh-0">
                  <inline-svg src="media/icons/duotune/art/art002.svg" />
                </span>
                <h3 class="fw-bold m-0 text-gray-800">Definir Variações</h3>
              </div>
              <div
                class="btn btn-icon btn-sm btn-active-light-primary mt-6"
                data-bs-dismiss="modal"
                @click="this.$emit('exibirModalVariacaoPadrao', false)"
              >
                <span class="svg-icon svg-icon-1 svg-icon lh-0">
                  <inline-svg src="media/icons/duotune/arrows/arr061.svg" />
                </span>
              </div>
            </div>
            <div class="card-body pt-8">
              <div
                class="row"
                v-for="(estoqueVariacao, i) in variacaoPadrao"
                v-bind:key="i"
              >
                <div class="col-10 mb-4">
                  <div class="fv-row">
                    <div class="d-flex justify-content-between">
                      <label class="form-label me-4">Descrição</label>
                      <div class="card-toolbar">
                        <button
                          v-if="this.consultarVariacao"
                          type="button"
                          @click="this.modalVariacoes(true)"
                          class="btn btn-sm btn-secondary px-2 py-0 m-0"
                        >
                          <span class="svg-icon svg-icon-1 m-0">
                            <inline-svg
                              src="media/icons/duotune/general/gen041.svg"
                          /></span>
                        </button>
                      </div>
                    </div>
                    <select
                      class="form-select mb-0"
                      data-placeholder="Selecione uma opção"
                      v-model="estoqueVariacao.descricao_variacao"
                    >
                      <template
                        v-for="variacao in this.variacoes"
                        :key="variacao.id"
                      >
                        <option :value="variacao.id">
                          {{ variacao.descricao }}
                        </option>
                      </template>
                    </select>
                    <div class="fv-plugins-message-container invalid-feedback">
                      {{ errosValidacao[i] }}
                    </div>
                  </div>
                </div>
                <div
                  :class="{ 'mb-10': errosValidacao[i] }"
                  class="col-2 mb-4 d-flex align-self-end"
                >
                  <div class="fv-row">
                    <button
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      title="Excluír esta variação"
                      type="button"
                      class="d-flex justify-content-center align-items-center btn-bg-light btn btn-active-light-danger svg-icon-white px-3 mb-2"
                      @click.prevent="excluirVariacao(i)"
                    >
                      <i class="la la-trash-o ms-1 fs-2"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-auto mb-4">
                  <button
                    type="button"
                    @click.prevent="adicionarVariacao()"
                    class="btn-bg-light btn btn-active-light-primary svg-icon-white"
                  >
                    <i class="la la-plus me-2 fs-3"></i>Adicionar variação
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer d-flex justify-content-end">
          <button
            class="btn btn-danger svg-icon-white me-2 mb-2"
            data-bs-dismiss="modal"
            @click="this.$emit('exibirModalVariacaoPadrao', false)"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg
                src="media/icons/duotune/arrows/arr015.svg"
                class="me-2"
              />Cancelar
            </span>
          </button>
          <button
            class="btn btn-success svg-icon-white mb-2"
            id="btnConfirmarVariacaoPadrao"
            @click="confirmarVariacaoPadrao()"
            v-bind:data-kt-indicator="this.loadingVariacaoPadrao ? 'on' : 'off'"
          >
            <span class="indicator-progress">
              <span
                class="spinner-border spinner-border-sm align-middle ms-1"
              ></span>
              Aguarde...
            </span>
            <span
              class="svg-icon svg-icon-1"
              v-if="!this.loadingVariacaoPadrao"
            >
              <inline-svg
                src="media/icons/duotune/arrows/arr016.svg"
                class="me-2"
              />Confirmar
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
  <VariacoesModal
    v-if="exibirVariacoes"
    :showSelection="false"
    @exibirModalVariacoes="modalVariacoes"
    @confirmarVariacao="carregarVariacoes"
  ></VariacoesModal>
</template>

<script>
import VariacoesModal from "../produtos/VariacoesModal.vue";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { hideModalId, getOrCreateInstanceModal } from "@/core/helpers/dom";
import { mapState } from "vuex";
import { useToast } from "vue-toastification";
const toast = useToast();

export default {
  emits: ["exibirModalVariacaoPadrao", "confirmarVariacaoPadrao"],
  components: { VariacoesModal },
  props: {
    estoque: { type: Object, required: false },
  },
  methods: {
    async confirmarVariacaoPadrao() {
      this.loadingVariacaoPadrao = true;
      this.confirmouCadastro = true;
      this.errosValidacao = [];
      const descricoesUnicas = [];

      if (this.variacaoPadrao.length > 0) {
        for (const [i, variacao] of this.variacaoPadrao.entries()) {
          if (variacao.descricao_variacao === null) {
            this.errosValidacao[i] =
              "A descrição da variação não pode ser vazia";
            this.confirmouCadastro = false;
          } else if (descricoesUnicas.includes(variacao.descricao_variacao)) {
            this.errosValidacao[i] =
              "A descrição da variação não pode ser repetida";
            this.confirmouCadastro = false;
          } else {
            descricoesUnicas.push(variacao.descricao_variacao);
          }
        }
      } else {
        await this.$swal.showInvalidAlert(
          "Nenhuma variação foi adicionada!",
          (alert) => {
            this.confirmouCadastro = false;
          }
        );
      }

      if (this.confirmouCadastro === true) {
        toast.success("Variação definida com sucesso!", { timeout: 2000 });
        this.$emit("confirmarVariacaoPadrao", this.variacaoPadrao);
        hideModalId("kt_modal_variacao_padrao");
        this.$emit("exibirModalVariacaoPadrao", false);
      }
      this.loadingVariacaoPadrao = false;
    },
    modalVariacoes(exibir) {
      this.exibirVariacoes = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_variacoes_consultar",
          /*open*/ () => {
            this.$utils.requestFocus("txtPesquisarVariacoes");
          },
          /*close*/ () => {
            this.modalVariacoes(false);
          }
        );
      }
    },
    async carregarVariacoes() {
      try {
        var ret = await this.$store.dispatch(
          "variacao/getVariacaoOData",
          "?$expand=VariacaoItem"
        );
        if (ret.value !== null && ret.value.length > 0) {
          this.variacoes = ret.value;
        }
      } catch (error) {
        console.log(error);
      }
    },
    adicionarVariacao() {
      this.variacaoPadrao.push({
        descricao_variacao: null,
      });
    },
    async excluirVariacao(i) {
      if (this.variacaoPadrao.length > 1) {
        await this.$swal.showQuestionAlert(
          "Deseja remover o registro?",
          (alert) => {
            if (alert.isConfirmed) {
              this.variacaoPadrao.splice(i, 1);
            }
          }
        );
      }
    },
    async verificarRestricoes() {
      if (this.user.User.EmitenteTipoUsuario.EmitenteRestricao != null) {
        this.user.User.EmitenteTipoUsuario.EmitenteRestricao.find((element) => {
          if (element.regra === "Permitir.Variacao.Consultar") {
            this.consultarVariacao = true;
          }
        });
      }
    },
  },
  async mounted() {
    await this.verificarRestricoes();
    this.carregarVariacoes();
    this.variacaoPadrao = JSON.parse(
      JSON.stringify(this.estoque.EstoqueVariacao)
    );
  },
  computed: {
    ...mapState("auth", ["user"]),
  },
  data() {
    return {
      consultarVariacao: false,
      confirmouCadastro: true,
      exibirVariacoes: false,
      variacaoPadrao: [],
      variacoes: [],
      loadingVariacaoPadrao: false,
      errosValidacao: [],
    };
  },
};
</script>

<style></style>
